<!--
 * @Description: 日程列表页
 * @Author: 山淑兰
 * @Date: 2019-09-10 10:05:16
 * @LastEditTime: 2020-07-02 14:18:00
 * @LastEditors: 山淑兰
 -->
<template>
	<div class="list">
		<div class="loading" v-if="loading">
			<van-loading type="spinner" color="#3b82f6" vertical size="30px" text-size="16px">加载中...</van-loading>
		</div>
		<div class="list-con" v-else>
			<div class="details-return" @click="goBack()">
				<img src="../../../assets/back.png">
			</div>
			<div class="list-con-main">
				<!-- 头部列表 -->
				<div class="list-head">
					<div class="list-head-title">
						<template v-if="$i18n.locale === 'zh-CN'">
							<ul class="meetinglist" v-if="datas">
								<li>
									<div class="meeting-date">
										<p>{{datas.prodate.split('月')[0]}}月</p>
										<p>{{datas.prodate.split('月')[1]}}</p>
									</div>
									<div class="meeting-info">
										<div class="meeting-title">
											{{ datas.roomtitle }}
										</div>
										<div class="meeting-time">
											<van-cell icon="underway-o" :value="datas.starttime + '-' + datas.endtime"
												class="forumDate-time" />
										</div>
										<div class="meeting-add">
											<van-cell :title="datas.roomname" icon="location-o" class="meetingTitle" />
										</div>
									</div>
									<div class="meeting-icon" v-if="datas.roomurl!=null">
										<a :href="datas.roomurl" target="_top">
											<img src="../../../assets/creame3.png">
											<p>点击观看直播</p>
										</a>
									</div>
								</li>
							</ul>
							<!-- <ul v-if="datas">
                <li>
                  <van-cell :title="datas.roomtitle" icon="send-gift-o" />
                </li>
                <li>
                  <van-cell :title="datas.prodate" icon="underway-o" />
                </li>

                <li :class="{ _link: datas.roomurl }">
                  <a :href="datas.roomurl" target="_top">
                    <van-cell
                      :title="datas.roomname"
                      icon="location-o"
                      class="list-head-title-address"
                  /></a>
                </li>
              </ul> -->
						</template>
						<template v-else>
							<ul class="meetinglist" v-if="datas">
								<li>
									<div class="meeting-date">
										<p>{{datas.prodate.split('月')[0]}}</p>
										<p>{{datas.prodate.split('月')[1]}}</p>
									</div>
									<div class="meeting-info">
										<div class="meeting-title">
											{{ datas.roomentitle }}
										</div>
										<div class="meeting-time">
											<van-cell icon="underway-o" :value="datas.starttime + '-' + datas.endtime"
												class="forumDate-time" />
										</div>
										<div class="meeting-add">
											<van-cell :title="datas.roomenname" icon="location-o"
												class="meetingTitle" />
										</div>
									</div>
									<div class="meeting-icon" v-if="datas.roomurl!=null">
										<a :href="datas.roomurl" target="_top">
											<img src="../../../assets/creame3.png">
											<p>点击观看直播</p>
										</a>
									</div>
								</li>
							</ul>
						</template>
					</div>
				</div>
				<!-- 标题部分 -->
				<!-- <h4>{{ $t('meeting.header.search.agenda') }}</h4> -->
				<!-- 日程列表内容部分 -->
				<template v-if="$i18n.locale === 'zh-CN'">
					<div class="schedule-list">
						<van-list :finished="finished" :offset="20">
							<div v-for="(items, indexs) in dataList" :key="indexs" 
								class="schedule-list-box">
								<!-- 主日程 -->
								<div class="schedule-list-con" :id="`top${items.proid}`">
									<div class="schedule-list-time">
										<p>
											<span>{{ items.startime }}</span>
											<span>~{{ items.endtime }}</span>
										</p>
									</div>
									<div class="schedule-list-r">
										<div class="schedule-list-title">
											<ul class="schedule-list-sub">
												<li class="major-title" v-show="items.topic !== ''">
													<div class="major-title-topic" v-html="nToBr(items.topic)"></div>
												</li>
												<li v-for="(i, j) in items.exData" :key="j">
													<div class="talker">
														<span>{{ i.rolename }}</span>
													</div>
													<div class="talker-name">
														<span v-for="(s, k) in i.exname" :key="k"
															@click="todetails(i.exid[k])" v-html="nToBr(s)"></span>
													</div>
												</li>
											</ul>
										</div>
									</div>
								</div>
								<!-- 子日程 -->
								<div class="schedule-list-c" v-if="items.children.length>0">
									<div class="schedule-list-c-line"></div>
									<div class="schedule-list-child" v-for="(item, indexs) in items.children"
										:key="indexs"  :id="`top${item.proid}`">
										<div class="schedule-list-child-time">
											<p>
												<span>{{ item.startime }}</span>
												<span>~{{ item.endtime }}</span>
											</p>
										</div>
										<div class="schedule-list-child-main">
											<!-- <div class="schedule-list-child-icon">
                        <van-icon name="star-o" />
                      </div> -->
											<ul>
												<li class="child-main-head">{{ item.topic }}</li>
												<li v-for="(i, j) in item.exData" :key="j" class="child-main-speaker">
													<div class="talker">
														<span>{{ i.rolename }}</span>
													</div>
													<div class="talker-name">
														<span v-for="(s, k) in i.exname" :key="k"
															@click="todetails(i.exid[k])" v-html="nToBr(s)"></span>
													</div>
												</li>
												<!-- <li class="child-main-speaker">
                          <span>{{ item.rolename }}</span>
                          <span>
                            <span
                              v-for="(i, k) in item.exname"
                              :key="k"
                              @click="todetails(item.exid[k])"
                              >{{ i }}</span
                            >
                          </span>
                        </li> -->
											</ul>
										</div>
									</div>
								</div>
							</div>
						</van-list>
					</div>
				</template>
				<template v-else>
					<div class="schedule-list">
						<van-list :finished="finished" :offset="20">
							<div v-for="(items, indexs) in dataList" :key="indexs" class="schedule-list-box">
								<!-- 主日程 -->
								<div class="schedule-list-con"  :id="`top${items.proid}`">
									<div class="schedule-list-time">
										<p>
											<span>{{ items.startime }}</span>
											<span>~{{ items.endtime }}</span>
										</p>
									</div>
									<div class="schedule-list-r">
										<div class="schedule-list-title">
											<ul class="schedule-list-sub">
												<li class="major-title" v-show="items.entopic !== ''">
													<div class="major-title-topic" v-html="nToBr(items.entopic)"></div>
												</li>
												<li v-for="(i, j) in items.exData" :key="j">
													<div class="talker">
														<span>{{ i.rolename }}</span>
													</div>
													<div class="talker-name">
														<span v-for="(s, k) in i.exenname" :key="k"
															@click="todetails(i.exid[k])" v-html="s!=null?nToBr(s):nToBr(i.exname[k])"></span>
													</div>
												</li>
											</ul>
										</div>
									</div>
								</div>
								<!-- 子日程 -->
								<div class="schedule-list-c" v-if="items.children.length>0">
									<div class="schedule-list-c-line"></div>
									<div class="schedule-list-child" v-for="(item, indexs) in items.children"
										:key="indexs"  :id="`top${item.proid}`">
										<div class="schedule-list-child-time">
											<p>
												<span>{{ item.startime }}</span>
												<span>~{{ item.endtime }}</span>
											</p>
										</div>
										<div class="schedule-list-child-main">
											<!-- <div class="schedule-list-child-icon">
                        <van-icon name="star-o" />
                      </div> -->
											<ul>
												<li class="child-main-head">{{ item.entopic }}</li>
												<li v-for="(i, j) in item.exData" :key="j" class="child-main-speaker">
													<div class="talker">
														<span>{{ i.rolename }}</span>
													</div>
													<div class="talker-name">
														<span v-for="(s, k) in i.exenname" :key="k"
															@click="todetails(i.exid[k])" v-html="s!=null?nToBr(s):nToBr(i.exname[k])"></span>
													</div>
												</li>
												<!-- <li class="child-main-speaker">
                          <span>{{ item.rolename }}</span>
                          <span>
                            <span
                              v-for="(i, k) in item.exname"
                              :key="k"
                              @click="todetails(item.exid[k])"
                              >{{ i }}</span
                            >
                          </span>
                        </li> -->
											</ul>
										</div>
									</div>
								</div>
							</div>
						</van-list>
					</div>
				</template>
			</div>
		</div>
	</div>
</template>
<script>
	export default {
		neme: 'list',
		data() {
			return {
				loading: false,
				datas: {},
				finished: false, //加载动画
				dataList: [],
				m: this.m,
				roomid: '',
				language: '',
				top: 0,
				language: 0, //0中文，1英文
			}
		},
		watch: {
			$route(to, from) {
				if (to.query.roomid != from.query.roomid && to.query.roomid) {
					this.roomid = to.query.roomid
					this.init()
				}
			},
		},
		created() {
			this.language = this.$route.query.language
			if (this.$route.query) {
				this.roomid = this.$route.query.roomid
				this.top = this.$route.query.top
				this.language = this.$route.query.language
				this.init()
			}
		},
		methods: {
			goBack() {
				this.$router.go(-1);
			},
			convertTime(time) {
				let end = time.split('(')[1].split(')')[0]
				// 将时间戳转时间格式
				let date = new Date(Number(end))
				let h = date.getHours()
				h = h < 10 ? '0' + h : h
				let m = date.getMinutes()
				m = m < 10 ? '0' + m : m
				return h + ':' + m
			},

			dealData(firstId, data) {
				let _temp = []
				for (let i = 0; i < data.length; i++) {
					if (data[i].upproid === firstId) {
						this.num++
						_temp.push(data.splice(i, 1)[0])
						i--
					}
				}
				for (let i = 0; i < _temp.length; i++) {
					_temp[i].children = this.dealData(_temp[i].proid, data)
				}
				return _temp
			},

			async init() {
				window.scrollTo({
					top: 0,
					behavior: "smooth",
				});
				let {
					roomid,
					m
				} = this.$route.query
				this.m = m
				if (roomid === undefined) {
					this.$router.push({
						path: '/meeting/place',
						query: {
							m
						},
					})
				}
				this.loading = true
				try {
					const {
						m,
						dateid = 0,
						roomid = 0,
						search = ''
					} = this.$route.query //获得路由的参数
					const _params = Object.assign({
							m,
							dateid,
							roomid,
						},
						search ? {
							search
						} : {}
					) //search 是空字符串 为false 有值是true
					const res = await this.$http.initScheduleInfo(_params)
					this.datas = res.RoomDateEntity
					if (this.language == 1){
						if(this.datas.prodate.indexOf('月')!=-1){
							this.datas.prodate = this.datas.prodate.replace('月','.')
						}
						if(this.datas.prodate.indexOf('日')!=-1){
							this.datas.prodate = this.datas.prodate.replace('日',' ')
						}
					}
					console.log(this.datas)
					res.childens[0].roomurl = res.RoomDateEntity.roomurl
					this.$emit('searchDatas', res.childens)
					this.$emit('BannerEntityList', res.BannerEntityList)

					let _list
					if (res.DateListEntity != null) {
						_list =
							res.DateListEntity[0].programListEntity[0].programs.programList
						this.num = 0
						const _data = this.dealData(0, _list)
						// console.log(_data, '处理后的日程数据')

						this.dataList = this.getSubAgendaData(_data)

						for (let i = 0; i < _data.length; i++) {
							this.dataList[i].children = this.getSubAgendaData(_data[i].children)
						}
					}
					console.log(this.dataList)
					this.loading = false
					
					let that = this
					if( that.top ){
						this.$nextTick(() => {
							setTimeout(function(){
								var PageId = document.querySelector("#top" + that.top);
								console.log(PageId.offsetTop)
								window.scrollTo({
									top: PageId.offsetTop,
									behavior: "smooth",
								});
							},1000)
						})
					}
				} catch (error) {
					console.error(error)
				}

				this.finished = true
			},

			getSubAgendaData(data) {
				let SubAgendaData = []
				for (let k = 0; k < data.length; k++) {
					let endtime = data[k].endtime,
						startime = data[k].starttime,
						children = data[k].children,
						proid = data[k].proid,
						exData = [],
						exenname = [],
						exid = [],
						roleenname = ''
					let exnameId = []
					for (let s = 0; s < data[k].expertList.length; s++) {
						exid.push(data[k].expertList[s].exid)

						exenname.push(data[k].expertList[s].exenname)
						roleenname = data[k].expertList[s].exrolemodel.roleenname
						exnameId.push({
							exname: data[k].expertList[s].exname,
							exid: data[k].expertList[s].exid,
						})

						exData = this.filterRolename(data[k].expertList)
					}

					SubAgendaData.push({
						children,
						startime,
						endtime,
						topic: data[k].topic,
						proid,
						exid,
						exData,
						//英文数据 ----
						entopic: data[k].entopic,
						exenname,
						roleenname,
					})
				}
				return SubAgendaData
			},
			filterRolename(data) {
				let _rolenameList = [], //已去重rolename
					_rolename = [] // 所有rolename

				//去掉重复的身份（rolename）
				for (let i in data) {
					_rolename.push(data[i].exrolemodel.rolename)
					let _indexof = _rolenameList.indexOf(_rolename[i])
					if (_indexof == -1) {
						_rolenameList.push(data[i].exrolemodel.rolename)
					}
				}
				let _identityList = [] //去重后的身份和姓名总数据
				_rolenameList.forEach((item) => {
					let _identity = {
						rolename: '',
						exname: [],
						exenname: [],
						exid: []
					}
					let _exname = [], //同一身份的嘉宾姓名
						_exenname = [],
						_exid = []
					for (let n in data) {
						if (item === data[n].exrolemodel.rolename) {
							_exname.push(data[n].exname)
							_identity.rolename = item
							_identity.exname = _exname
							_exenname.push(data[n].exenname)
							_identity.exenname = _exenname
							_exid.push(data[n].exid)
							_identity.exid = _exid
						}
					}
					_identityList.push(_identity)
				})

				return _identityList
			},
			/**
			 * @description 进入到子路由 封装的方法
			 * @param {Objcet} param 路由需要的参数
			 */
			todetails(param) {
				const exid = param
				this.$router.push({
					path: '/meeting/details',
					query: {
						m: this.m,
						language: this.language,
						exid
					},
				})
			},
			nToBr (str){
				if( str ){
					return str.replace(/\\n/g,'<br/>');
				}else{
					return str
				}
			
			},
		},
	}
</script>
<style lang="scss" scoped>
	// .list {
	//   width: 100%;
	//   background: #efeff4;
	//   .list-con {
	//     .list-con-main {
	//       margin: 10px;
	//       font-size: 26px;
	//     }
	//     .list-head {
	//       box-shadow: 0 2px 12px rgba(0,0,0,0.04);
	//       .list-head-title {
	//         box-shadow: 0 2px 12px rgba(0,0,0,0.04);
	//         margin: 1px 0px 6px 0px;
	//         ul {
	//           padding: 10px 0;
	//           background: #fff;
	//           li {
	//             .van-cell {
	//               font-size: 28px;
	//               padding: 12px 16px;
	//               font-weight: 440;
	//               color: #000;
	//               line-height: 36px;
	//               i {
	//                 width: 40px;
	//                 font-size: 34px;
	//                 color: #000;
	//                 line-height: 36px;
	//               }
	//             }
	//             .list-head-title-address {
	//               i {
	//                 color: #3b82f6;
	//                 font-weight: bold;
	//               }
	//             }
	//           }
	//         }
	//       }
	//     }
	//     h4 {
	//       height: 80px;
	//       line-height: 80px;
	//       margin-left: 10px;
	//       font-size: 28px;
	//     }
	//     .schedule-list {
	//       margin-bottom: 100px;
	//       .schedule-list-box {
	//         margin-bottom: 20px;
	//         background: #fff;
	//         box-shadow: 0 2px 12px rgba(0,0,0,0.04);
	//         .schedule-list-head {
	//           padding: 20px 0;
	//           margin-bottom: 20px;
	//           font-size: 28px;
	//           display: flex;
	//           border-bottom: 1px solid #e2e8f0;

	//           .schedule-list-time {
	//             width: 180px;
	//             padding-left: 16px;
	//             color: #3b82f6;
	//           }
	//           .schedule-list-title {
	//             flex: 1;
	//             .schedule-list-sub {
	//               & > li {
	//                 padding: 8px 0;
	//                 line-height: 36px;
	//                 padding-right: 6%;
	//               }
	//               .major-title {
	//                 display: flex;
	//                 .major-title-topic {
	//                   flex: 1;
	//                   font-size: 28px;
	//                 }
	//                 > .van-cell {
	//                   width: 42px;
	//                   display: inline-block;
	//                   padding: 0px;
	//                 }
	//                 i {
	//                   font-size: 34px;
	//                   color: #000;
	//                   line-height: 36px;
	//                 }
	//                 .van-cell:not(:last-child)::after {
	//                   border: none;
	//                 }
	//               }
	//               .talker {
	//                 font-weight: bolder;
	//               }
	//             }
	//           }
	//         }
	//         .schedule-list-child {
	//           display: flex;
	//           font-size: 28px;
	//           .schedule-list-child-time {
	//             width: 190px;
	//             padding-left: 16px;
	//             font-size: 28px;
	//           }
	//           .schedule-list-child-main {
	//             flex: 1;
	//             border-left: 2px solid #e2e8f0;
	//             position: relative;
	//             padding-left: 20px;
	//             border-top-left-radius: 10px;
	//             margin-left: 22px;
	//             padding-bottom: 20px;
	//             .schedule-list-child-icon {
	//               width: 32px;
	//               height: 32px;
	//               position: absolute;
	//               top: 6px;
	//               left: -18px;
	//               background: #fff;
	//               border: 1px solid #3b82f6;
	//               border-radius: 32px;
	//               text-align: center;
	//               > .van-icon {
	//                 font-size: 28px;
	//                 color: #3b82f6;
	//               }
	//             }
	//             ul {
	//               margin: 0 16px 0 10px;

	//               .child-main-head,
	//               .child-main-speaker {
	//                 margin-bottom: 20px;
	//                 font-size: 28px;
	//               }
	//               .child-main-speaker {
	//                 color: #3b82f6;
	//                 > div {
	//                   color: #3b82f6;
	//                   font-weight: 400;
	//                 }
	//                 > div:first-child {
	//                   font-weight: bolder;
	//                   color: #000;
	//                   margin-right: 20px;
	//                 }
	//               }
	//             }
	//           }
	//         }
	//       }
	//     }
	//   }
	//   ._link {
	//     span {
	//       color: #3b82f6;
	//     }
	//   }
	//   .talker-name {
	//     color: #3b82f6;
	//     display: flex;
	//     flex-wrap: wrap;
	//     flex-direction: row;
	//     > span {
	//       margin-right: 20px;
	//     }
	//   }
	// }
	.list {
		margin-bottom: 80px;
		font-size: 26px;
		line-height: 1.5;
		padding: 0 20px 20px;

		.details-return {
			position: fixed;
			right: 0;
			bottom: 80px;
			width: 84px;
			height: 60px;
			z-index: 100;
			background: #3b82f6;
			border-radius: 30px 0 0 30px;
			text-align: center;
			line-height: 60px;
			color: #fff;

			img {
				height: 100%;
			}
		}

		.meetinglist {
			background: #3b82f6;
			color: #fff;
			margin-top: 20px;
			padding: 20px 20px 10px 0;
			-webkit-box-shadow: 0 2px 12px rgba(0,0,0,0.04);
			box-shadow: 0 2px 12px rgba(0,0,0,0.04);
			border-radius: 12px;

			li {
				display: flex;

				.meeting-date {
					width: 160px;
					padding: 10px 0 0 0;
					font-weight: bold;
					display: flex;
					align-items: flex-start;
					flex-direction: column;
					justify-content: flex-end;

					p {
						font-size: 42px;
						color: #e2e8f0;
					}

					p:last-child {
						font-size: 64px;
						color: #cbd5e1;
						margin-top: 5px;
					}
				}

				.meeting-info {
					flex: 1;
					color: #fff;
					padding-right: 20px;

					.meeting-title {
						margin-bottom: 10px;
					}

					.van-cell {
						padding: 10px 0;
						font-size: 26px;
						line-height: 1.5;
						background: none;
						color: #fff;

						.van-cell__left-icon {
							line-height: 40px;
							color: #fff;
							font-size: 28px;
						}

						.van-cell__value--alone {
							color: #fff;
						}
					}
				}

				.meeting-icon {
					width: 160px;
					padding-bottom: 20px;
					display: flex;
					align-items: flex-end;
					justify-content: center;

					a {
						color: #fff;
						display: block;
						text-align: center;
					}

					img {
						width: 70px;
						margin: 0 auto;
					}

					p {
						font-size: 12px;
						margin-top: 5px;
					}
				}
			}

		}

		.schedule-list-box {
			background: #fff;
			margin-top: 20px;
			padding: 20px;
			-webkit-box-shadow: 0 2px 12px rgba(0,0,0,0.04);
			box-shadow: 0 2px 12px rgba(0,0,0,0.04);
			border-radius: 12px;

			.schedule-list-con {
				display: flex;
			}

			.schedule-list-time {
				width: 145px;
				font-size: 26px;

				span {
					display: block;
				}

				span:last-child {
					padding-left: 10px;
				}
			}

			.schedule-list-r {
				flex: 1;

				.talker span {
					font-weight: bold;
				}

				.talker-name {
					color: #3b82f6;
					display: flex;
					flex-wrap: wrap;
					flex-direction: row;

					>span {
						margin-right: 20px;
					}
				}
			}

			.schedule-list-c {
				position: relative;
				border-top: 1px solid #e2e8f0;
				margin-top: 20px;
				padding: 10px 0;

				.schedule-list-c-line {
					position: absolute;
					top: 40px;
					left: 113px;
					bottom: 10px;
					width: 2px;
					background: #e2e8f0;
				}

				.schedule-list-child {
					display: flex;

					margin-top: 20px;

					.schedule-list-child-time {
						width: 145px;
						position: relative;
						font-size: 26px;

						span {
							display: block;
						}

						span:last-child {
							padding-left: 10px;
						}
					}

					.schedule-list-child-time:after {
						position: absolute;
						display: block;
						content: '';
						width: 16px;
						height: 16px;
						background: #3b82f6;
						border-radius: 10px;
						left: 106.5px;
						top: 10px;
						z-index: 100;
					}

					.schedule-list-child-main {
						flex: 1;

						.talker span {
							font-weight: bold;
						}

						.talker-name {
							color: #3b82f6;
							display: flex;
							flex-wrap: wrap;
							flex-direction: row;

							>span {
								margin-right: 20px;
							}
						}
					}
				}
			}
		}
	}
</style>
